// Imports
import { MyProgram } from 'src/modules/my-program/jsx/component.jsx';
import { AskUs } from 'src/modules/ask-us/jsx/component.jsx';
import { WantToLinks } from 'src/modules/i-want-to-links/jsx/component.jsx';
import { ServiceIndicator } from "src/modules/alerts/jsx/service-indicator.jsx";

// Stateless components

export function MyProgramPage(props) {

    //
    // Render
    //

    return (
        <>
            <ServiceIndicator />
            <div className="page-inner__content">
                <MyProgram />
            </div>
            <div className="my-program__links">
                <div className="my-program-links__wrapper" data-ga-label="Links">
                    <AskUs />
                    <WantToLinks />
                </div>
            </div>
        </>
    );
};
